import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-developer',
  templateUrl: './developer.component.html',
  styleUrls: ['./developer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DeveloperComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/developer/developer.component.ts